import { render, staticRenderFns } from "./SeleccionHeaders.vue?vue&type=template&id=1f8d6166&"
import script from "./SeleccionHeaders.vue?vue&type=script&lang=js&"
export * from "./SeleccionHeaders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports